
<!DOCTYPE html>
<html lang="en">

<head>
   <meta charset="utf-8">
   <meta http-equiv="X-UA-Compatible" content="IE=edge">
   <meta name="viewport" content="width=device-width, initial-scale=1">
   <meta name="robots" content="noindex">
   <title>קרסו מוטורס</title>
</head>

<body [attr.dir]="site?.direction" [ngClass]="site?.direction">
   <app-spinner *ngIf="loading"></app-spinner>
   <ng-container *ngIf="!loading">
      <div class="header" [attr.dir]="site?.logoPosition === 'left' ? 'ltr' : 'rtl'" fxLayout="row">
         <a class="logo-link" [href]="site?.logoLink" target="_blank">
            <img [src]="site?.logo.url" class="logo" alt="logo">
         </a>
         <div fxFlex="auto" *ngIf="site?.spaceLogoAndItems"></div>
         <div fxLayout="row" fxLayoutAlign="start center">
            <div *ngFor="let item of site?.headerMenuItems" class="menu-item">
               <a [href]="item.link" target="_blank">
                  <span>{{ item.title }}</span>
               </a>
            </div>
         </div>
      </div>
      <div class="content" fxLayout="row" [fxLayoutAlign]="position(site.formPosition)">
         <img class="bg-img" [src]="site?.bgImage.url">

         <div *ngIf="step === 'step1'" class="jumbotron step" id="step1" [style.background]="site?.backgroundColor" [style.color]="site?.fontColor">
               <div class="col-lg-12">
                  <p style="text-align: center;">
                    <quill-view [content]="site?.title" format="html" theme="snow"></quill-view>
                    </p>
                  <p class="lead">{{ site?.formTitle }}</p>
               </div>
               <div fxLayout="row" fxLayout.lt-sm="column" style="margin:0;">
                  <div class="col-lg-6" [formGroup]="formGroup">
                     <div class="form-group">
                        <label for="username">{{ site?.userNameTitle || 'שם משתמש לרשת הארגונית' }}</label>
                        <input name="username" formControlName="userName" type="text" class="form-control try" id="username" [placeholder]="site?.userNamePlaceholder ||'משתמש'">
                     </div>
                     <div class="form-group">
                        <label for="password">{{ site?.passwordTitle || 'סיסמה ברשת הארגונית' }}</label>
                        <input name="password" formControlName="password" type="password" class="form-control" id="password" [placeholder]="site?.passwordPlaceholder || 'סיסמה'">
                     </div>
               
                   
                        <div class="form-group" *ngFor="let field of (site?.additionalFields || []); let i = index">
                           <label for="field.title">{{ field.title || 'שדה '+(i + 1) }}</label>
                           <input [attr.name]="field.title" class="form-control" id="tue" [placeholder]="field?.placeholder || 'שדה '+(i + 1)">
                        </div>
                
              

               
                   
                     <div class="form-check" *ngIf="site?.selectionField">
                        <label for="exampleInputPassword1">{{ site?.selectionFieldTitle }}</label><br>
                        <ng-container [ngSwitch]="site?.selectionFieldType">
                           <mat-radio-group *ngSwitchCase="'radio'" fxLayout="column" formControlName="selectionField">
                                 <mat-radio-button [attr.dir]="site?.direction" class="" *ngFor="let option of site?.selectionFieldOptions; let i = index;" [value]="option">
                                    {{ option }}
                                 </mat-radio-button>
                           </mat-radio-group>
                           <mat-form-field *ngSwitchCase="'select'" >
                              <mat-label>{{ site?.selectionFieldPlaceholder }}</mat-label>
                              <mat-select formControlName="selectionField">
                                <mat-option *ngFor="let option of site?.selectionFieldOptions" [value]="option">{{ option }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                        </ng-container>
                     </div>
                  </div>
                  <div class="col-lg-6">
                     <img class="col-xs-12 introimage" [src]="site?.contentImage.url">
                  </div>
               </div>
               <br>
               <button 
                  mat-raised-button
                  color="primary"
                  (click)="submitForm()"
                  type="submit"
                  name="send"
                  id="sendButton" class="btn btn-primary">{{ site?.submitButtonLabel }}
               </button>
               <div id="error" style="text-align:right;color:red;padding:10px 0;">
                  {{ error }}
               </div>
         </div>

         <div *ngIf="step === 'step2'" class="jumbotron step" id="step2" [style.background]="site?.backgroundColor" [style.color]="site?.fontColor">
            <p>
               <quill-view [content]="site?.confirmationMessage" format="html" theme="snow"></quill-view>
            </p>
         </div>

      </div>

      <footer class="footer"  [attr.dir]="site?.footerLogoPosition === 'left' ? 'ltr' : 'rtl'" fxLayout="row" fxLayoutAlign="start center">
         <a class="logo-link" [href]="site?.logoLink" target="_blank">
            <img [src]="site?.logo.url" class="logo" alt="logo">
         </a>
         <div class="footer-content">
            <span class="text-muted">{{ site?.rightsMessage }}</span>
         </div>
      </footer>
   </ng-container>
</body>

</html>